var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import ReduxApp from '../redux/ReduxApp';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { PageContent, PageHeader, ToastContainer } from 'grilnica-reactstrap';
import Authorize from './auth/Authorize';
import { apiGet } from '../api';
import { CONSTANTS } from '../constants';
import { ACTION_TYPES } from '../redux/action/ActionTypes';
import Header from './header/Header';
import { redirectToAuthPage } from './auth';
import MainMenu from './menu/MainMenu';
import Logout from './auth/Logout';
import ErrorModal from './error/ErrorModal';
import ForbiddenPage from './forbidden/ForbiddenPage';
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isInitialized: false,
        };
        var _a = _this.props, store = _a.store, subsystem = _a.subsystem;
        store.dispatch({ type: ACTION_TYPES.AUTH_SET_STATE, state: { subsystem: subsystem } });
        return _this;
    }
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, store, subsystem, token, user, privileges, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, store = _a.store, subsystem = _a.subsystem;
                        token = JSON.parse(localStorage.getItem('token'));
                        if (!token) return [3 /*break*/, 6];
                        user = void 0;
                        privileges = void 0;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, apiGet(CONSTANTS.authUrl + '/api/check')];
                    case 2:
                        // При наличии токена получаем информацию о пользователе
                        user = _b.sent();
                        return [4 /*yield*/, apiGet(CONSTANTS.authUrl + '/api/check/privilege/' + subsystem.subsystemId)];
                    case 3:
                        privileges = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _b.sent();
                        // При неверном токене отправка на страницу авторизации
                        if (err_1.status === 401) {
                            localStorage.removeItem('token');
                            redirectToAuthPage();
                        }
                        else {
                            // TODO: show error modal
                            throw err_1;
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        store.dispatch({ type: ACTION_TYPES.AUTH_SET_STATE, state: { user: user, privileges: privileges } });
                        _b.label = 6;
                    case 6:
                        this.setState({ isInitialized: true });
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.render = function () {
        var urlPrefix = this.props.urlPrefix;
        var isInitialized = this.state.isInitialized;
        if (isInitialized) {
            var _a = this.props, store = _a.store, subsystem = _a.subsystem, isContentContainer = _a.isContentContainer, menuItems = _a.menuItems;
            return (React.createElement(ReduxApp, { store: store },
                React.createElement(BrowserRouter, { basename: urlPrefix }, window.location.pathname === (urlPrefix || '') + '/auth' ? (React.createElement(Route, { path: '/auth', component: Authorize })) : (React.createElement("div", null,
                    React.createElement(PageHeader, null,
                        React.createElement(Header, { subsystem: subsystem })),
                    React.createElement(ErrorModal, null),
                    React.createElement(ToastContainer, null),
                    React.createElement(PageContent, { isContainer: isContentContainer === undefined || isContentContainer },
                        React.createElement(MainMenu, { items: menuItems }),
                        this.props.children,
                        React.createElement(Switch, null,
                            React.createElement(Route, { path: '/auth', component: Authorize }),
                            React.createElement(Route, { path: '/logout', component: Logout }),
                            React.createElement(Route, { exact: true, path: '/forbidden', component: ForbiddenPage }))))))));
        }
        else {
            return null;
        }
    };
    return App;
}(Component));
export default App;
//# sourceMappingURL=App.js.map